import { render, staticRenderFns } from "./thanks-letter-cover-2020.vue?vue&type=template&id=59667517&"
import script from "./thanks-letter-cover-2020.vue?vue&type=script&lang=js&"
export * from "./thanks-letter-cover-2020.vue?vue&type=script&lang=js&"
import style0 from "./thanks-letter-cover-2020.vue?vue&type=style&index=0&id=59667517&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports